import styled from "styled-components";
import { Link } from "react-router-dom";
import { FontFamilies, TextColors } from "@abel-technologies-as/components";

const IconWrapper = styled.div`
	margin-right: 5.5px;
`;

const StyledLink = styled(Link)`
	color: ${TextColors.Primary};
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	font-family: ${FontFamilies.InterMedium};
	text-decoration: none;
`;

const DropDownContainer = styled.div`
	padding: 14px 16px;
`;

export { IconWrapper, StyledLink, DropDownContainer };
